import * as React from 'react'
import { FC } from 'react'
import MouseFocus from '../MouseFocus'
import './Landing.scss'
import Carousel from '../TitleDetails/fragments/Carousel'

import { VMTitle } from '../../index'

interface Props {
    sliderItems?: VMTitle[]
}

const Landing: FC<Props> = ({ sliderItems = [] }) => {
    return (
        <div className="Landing">
            <MouseFocus>
                <Carousel
                    className="Landing__carousel"
                    centeredSlides={true}
                    loop={true}
                    breakpoints={{ 1024: { slidesPerView: 4 } }}
                    slidesPerView={2}
                    spaceBetween={0}
                >
                    {sliderItems.map((slide, index) => (
                        <a href={slide.url} key={index} className="Landing__slide">
                            <div className="Landing__slide__content">
                                <img src={slide.image} alt={slide.title} />
                            </div>
                        </a>
                    ))}
                </Carousel>
            </MouseFocus>
        </div>
    )
}

export default Landing
